module.exports = __webpack_public_path__ + "static/media/view campus.9f2f1b78.svg";